import React, { Component } from "react";
import {  Button, Form, Icon, Grid } from "tabler-react";
import { mail } from "../../../herramientas/Forms";
import axios from 'axios';
import Map from "../../../components/maps/Map"

import {
  setKey,
  setDefaults,
  setLanguage,
  setRegion,
  fromAddress,
  fromLatLng,
  fromPlaceId,
  setLocationType,
  geocode,
  RequestType,
} from "react-geocode";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";



class  PatiosForm extends Component {
  constructor(props) {

console.log(props)
    super(props);


    setDefaults({
      key: "AIzaSyDxYRdbyPuyEIOwuVBVwCoaI8ZL6JMPnMQ", // Your API key here.
      language: "en", // Default language for responses.
      region: "es", // Default region for responses.
    });


    this.state = {
                  coordenadas:{ "lat":0,"lng":0},
                  urlCorrecta:  true,
                  url: "",
                  nombre: "",
                  direccion: "",
                  ciudad: "",
                  cp: "",
                  estatus: false,
                  correo: "",
                  correoEstatus: 0,
                  Etiqueta_arraylist:[],
                  che: false,
                  crudbutonEnable: true, // Se desabilita cuando se hace click
                  accion: this.props.accion, //'nuevo'// modificar, nuevo
};
    this.checarEtiqueta=false;
    this.Etiqueta_array=[];
    this.etiquetaId=0;
    this.patioObject=[];
    this.enableSave = this.enableSave.bind(this);
    this.changeUrl = this.changeUrl.bind(this);
    this.updateForm = this.updateForm.bind(this);
}
isEnable=(Accion)=>{
  let borrar= "personas_borrar";
  let actualizar= "personas_editar";
  let agregar= "personas_agregar";
  var privilegios= this.props.stor.privilegios_object; var perfil = JSON.parse(sessionStorage.getItem("perfil"));
  for (let i = 0;  i<privilegios.length; i++) {
    if(Accion === "borrar"){ 
      if( privilegios[i].clave === borrar){ if(perfil.privilegios.filter(word => word.idPrivilegio === privilegios[i].id).length > 0 ){return true}}}
    if(Accion === "actualizar"){if( privilegios[i].clave === actualizar){ if(perfil.privilegios.filter(word => word.idPrivilegio === privilegios[i].id).length > 0 ){return true}}}
    if(Accion === "agregar"){if( privilegios[i].clave === agregar){ if(perfil.privilegios.filter(word => word.idPrivilegio === privilegios[i].id).length > 0 ){return true}}}
  }
  return false
}

  componentDidMount =() => {
      

    if(this.state.accion !== 'nuevo'){
      this.setState({nombre: this.props.elementos.nombre});
      this.setState({aPaterno: this.props.elementos.aPaterno});
      this.setState({aMaterno: this.props.elementos.aMaterno});
      this.setState({skyangel: this.props.elementos.skyangel});
      this.setState({correo: this.props.elementos.correo});
      this.setState({Etiqueta_arraylist: this.Etiqueta_array});
      this.setState({correoEstatus: this.props.elementos.correoEstatus });
      this.personaObject= this.props.elementos;
    }else{
        this.personaObject={"nombre": "", "aPaterno": "", "aMaterno": "", "skyangel": 0, "correo": "","correoEstatus": 0, "telefono": "","whatsappEstatus":false }
        }
  }

  enableSave =() =>{
    if(this.state.nombre.length > 0 && this.state.direccion.length > 0
      && (this.state.ciudad.length > 0 && this.state.url.length > 0) ){
      return false;
    }else{
      return true
    }
  }

  changeName =(event) => {
    
    this.setState({nombre: event.target.value});
  }
  changeDireccion =(event) => {
    
    this.setState({direccion: event.target.value});

  }
  changeCp =(event) => {
    
    this.setState({cp: event.target.value});

  }

  changeEstatus = (event) =>{
    event.target.checked ? this.setState({estatus: 1}) : this.setState({estatus: 0 });
  }


  changeCiudad =(event) => {

    this.setState({ciudad: event.target.value});

  }


 
  delete()    { this.props.getfuntion("delete", "", this.state.id); this.setState({ crudbutonEnable: false });}
  // crud_put()  { this.props.getfuntion("put", this.personaObject);   this.setState({ crudbutonEnable: false });}
  crud_post() { 
    let patioObject = {
       "nombre":this.state.nombre,
       "direccion":this.state.direccion,
       "ciudad":this.state.ciudad,
       "cp":parseInt(this.state.cp),
       "latitud":this.state.coordenadas.lat,
       "longitud":this.state.coordenadas.lng,
       "idTransportista":this.props.data.idTransportista,
       "idPlataforma":this.props.data.idPlataforma
    }
    
    this.props.getfuntion("patios","","post", "",patioObject,"","",this.props.hiddenModal).then((response)=>{  

      this.props.cerrarModal();
      this.props.updateData(response);

 

      
    });
              
  }

  geturl = async link => {
    try {
        return await axios({
            method: "get",
            url: link,
            maxRedirects: 0
        });
    } catch (e) {
        if (Math.trunc(e.response.status / 100) === 3) {
            return geturl(e.response.headers.location);
        } else {
            throw e;
        }
    }
};


async getData(url) {
  
  try {


    
    const response = await fetch(url,{method: "GET",
      headers: new Headers({
        'Cache-Control':"no-cache"
       }),
        mode: 'no-cors',
        withCredentials: false,
    });

    console.log(response)
    if (!response.ok) {

      
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    console.log(json);
  } catch (error) {
    console.error(error.message);
  }
}




  updateForm(data){

   geocode(RequestType.LATLNG, data.lat + ','+ data.lng)
  .then(({ results }) => {
    const address = results[0].address_components;
    const get = (type) => address.find(c => c.types.includes(type));
    const calle = get("route")?.long_name || "";
    const numero = get("street_number")?.long_name || "";
    const localidad = get("sublocality")?.long_name || get("locality")?.long_name || "";
    const ciudad = get("locality")?.long_name || get("administrative_area_level_1")?.long_name || "";
    const cp = get("postal_code")?.long_name || "";
    const direccion = (calle + " " + numero + " " + localidad).trim();
    this.setState({ direccion: direccion || results[0].formatted_address || "Sin dirección" });
    this.setState({ ciudad: ciudad || "Sin ciudad" });
    this.setState({ cp });
    return address;
  })
  .catch(console.error);

    console.log(data)

  }

  changeUrl(event){
    this.setState({url: event.target.value});

   let url = (event.target.value);
   let banderaValidacion =  false;

   if(url != null || url != ""){
  
    let arrayCords = url.match(/([-0-9]+\.[0-9]+)%2C([-0-9]+\.[0-9]+)/) || url.match(/@([-0-9]+\.[0-9]+),([-0-9]+\.[0-9]+),/);  
   
     console.log(arrayCords);

    const latRegex = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,15}/g;

    const lngRegex = /^-?(([-+]?)([\d]{1,3})((\.)(\d+))?)/g;

    if( arrayCords != null && (arrayCords.length == 3) && (latRegex.test(arrayCords[1])) && lngRegex.test(arrayCords[2])) {
           banderaValidacion =  true;
           this.setState({coordenadas: { "lat": parseFloat(arrayCords[1]), "lng":parseFloat(arrayCords[2])}});
           console.log("Se valido latitud")
    } else{
      banderaValidacion = false;
    }
    this.setState({urlCorrecta: banderaValidacion});

   }


    
  }

  render() {
    return (
<div>
    { this.state.accion === "modificar"? <h1>({this.props.elementos.id}) { this.props.elementos.nombre }</h1>:null }
  {
    /**
     * Formulario personas
     */
   }

          

                <Grid.Row>
                  <Grid.Col>
                    <Form.Group label="Nombre del Patio">
                      <Form.Input name="nombre" type="text" value={ this.state.nombre } onChange={this.changeName} />
                      {!this.state.nombre.length > 0 ? 
                       <div className="error-message">
                       <span className="error-text">
                       Introduce un nombre del patio 
                       </span>
                      </div>
                      
                      : ""
                      }
                    </Form.Group>
                  </Grid.Col>

                  </Grid.Row>

                <Grid.Row>
                  <Grid.Col>
                    <Form.Group label="Url de la ubicacion del Patio">
                      <Form.Input name="nombre" type="url"  value={ this.state.url } onChange={this.changeUrl} />
                      {!this.state.urlCorrecta ? 
                       <div className="error-message">
                       <span className="error-text">
                       Introduce una url correcta 
                       </span>
                      </div>
                      
                      : ""
                      }

                      <Map
                      
                      coordenadas={this.state.coordenadas}
                      data={this.updateForm}>

                      </Map>
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col className="ocultar">
                    <Form.Group label="Direccion">
                      <Form.Input name="direccion" type="text" value={ this.state.direccion } onChange={this.changeDireccion} />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col className="ocultar">
                    <Form.Group label="Codigo Postal">
                      <Form.Input name="cp" type="text" value={ this.state.cp } onChange={this.changeCp} />
                    </Form.Group>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  
                  <Grid.Col className="ocultar">
                    <Form.Group label="Ciudad" >
                      <Form.Input name="ciudad" type="text" value={ this.state.ciudad }  onChange={this.changeCiudad} />
                    </Form.Group>
                  </Grid.Col>
                  
                <Grid.Col>
                      <Form.Group label="Activo">
                        <Form.Switch name="estatus" label=" " value={ this.state.estatus } checked={this.state.estatus} onChange={this.changeEstatus} />
                      </Form.Group>
                 </Grid.Col>
                 

                </Grid.Row>
        
  {
    /**
     * Lista de etiquetas
     */
   }


  <div className="float-right">
    {this.isEnable("actualizar") || this.isEnable("agregar") ?
      <span class="badge">
        <Button
          target="_blank" size="sm" RootComponent="a" color="primary"
          disabled={ this.enableSave() || !this.state.crudbutonEnable }
          onClick= { this.state.accion === "modificar" ? () => this.crud_put() : () => this.crud_post()} >
          <span class="badge"><Icon link={true} name="save" />Guardar</span>
        </Button>
      </span>
    :null}
    {/* { this.state.accion === "modificar" && this.isEnable("borrar")? <span class="badge">
    <Button target="_blank" size="sm" RootComponent="a" color="primary" onClick= { () => this.delete()} disabled={!this.state.crudbutonEnable}>
      <span class="badge"><Icon link={true} name="trash" />Borrar</span>
    </Button>
    </span>
    :
    null
    } */}
  </div>
</div>
    );
  }
}
export default PatiosForm;
